// extracted by mini-css-extract-plugin
export default {"main":"PageNotFound_main__0DNXs","message":"PageNotFound_message__U6GKz","title":"PageNotFound_title__Y8T53","text":"PageNotFound_text__pkKYw"};